import React, { useState, createContext, useContext, useCallback } from 'react';

const CourseUIContext = createContext();

/**
 * CourseUIContextProvider - Manages only UI state for the course page
 * This context should be used at the Course component level, not globally,
 * so that state automatically resets when navigating between courses.
 */
export const CourseUIContextProvider = ({ children }) => {
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [selectedToggle, setSelectedToggle] = useState('docchat');
  const [expanded, setExpanded] = useState(true);

  const clearSelectedTopic = useCallback(() => {
    setSelectedTopic(null);
  }, []);

  const value = {
    // UI State
    selectedTopic,
    setSelectedTopic,
    selectedToggle,
    setSelectedToggle,
    expanded,
    setExpanded,
    clearSelectedTopic,
  };

  return <CourseUIContext.Provider value={value}>{children}</CourseUIContext.Provider>;
};

export const useCourseUI = () => {
  const context = useContext(CourseUIContext);
  if (!context) {
    throw new Error('useCourseUI must be used within a CourseUIContextProvider');
  }
  return context;
};

// Legacy export for backward compatibility - will be removed after refactoring all components
export const CourseContextProvider = CourseUIContextProvider;
export const useCourse = useCourseUI;
